var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pw-rules"},[_c('h4',[_vm._v("password rules:")]),_vm._l((_vm.passwordRules),function(rule,i){return _c('p',{key:i,class:_vm.validClass(rule)},[_vm._v(" "+_vm._s(rule.desc)+" ")])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }